<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="types"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a type ID by choosing its name
     *
     */
    export default {
        name: 'ies-portalContentTypeKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                types: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getTypes();
        },
        methods: {
            getTypes:function(){
                axios.get('/api/portal-content-types')
                .then(function(response){
                    var types = [];
                    response.data.forEach(function(record){
                        types.push({ text: record.name, value: record.portal_content_type_key });
                    });
                    this.types = types;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
